import mitt from 'mitt';

export const CardDirtyBus = mitt();
